import React from "react";
import BookableTranslations from "../../Bookable/ModuleTranslations/fr";
import {
  RATE_TYPE,
  RESTRICTION_TYPE,
  DEVICE_TYPE,
  CODE_TYPE,
  SHARING_TYPE,
  RESTRICTION_VALUE_TYPE,
} from "../../../Common/constants";
import { removeIconSetIdentifier } from "../ModuleDefinition";
import { getTranslatedCountryList } from "../../../../../lib/intlUtils";

const customBookableTranslations = BookableTranslations.fields.form.map(field => {
  if (field.fieldName === "isVisible") {
    field.displayName = "Visible sur le moteur de réservation";
  }
  return field;
});

export default {
  locale: "fr",
  name: "Promotions",
  filterFields: [
    ["isActive", "bool"],
    ["isVisible", "bool"],
    "ticker",
    "name",
    [
      "promotionType",
      "selector",
      [
        { label: "Réduction % ", value: RATE_TYPE.PERCENTAGE },
        { label: "Message promotionnel", value: RATE_TYPE.HIGHLIGHT_MESSAGE },
        { label: "Réduction fixe/jour", value: RESTRICTION_VALUE_TYPE.MONEY },
        { label: "Type 3x2", value: RATE_TYPE.GIVE_NIGHT },
      ],
    ],
    [
      "group",
      "selector",
      [
        { label: "Un", value: "1" },
        { label: "Deux", value: "2" },
        { label: "Trois", value: "3" },
        { label: "Quatre", value: "4" },
        { label: "Cinq", value: "5" },
        { label: "Six", value: "6" },
        { label: "Sept", value: "7" },
        { label: "Huit", value: "8" },
        { label: "Neuf", value: "9" },
        { label: "Dix", value: "10" },
      ],
    ],
    "CODE",
    [
      "sharingType",
      "selector",
      [
        { label: "-", value: SHARING_TYPE.SIMPLE },
        { label: "Partagé", value: SHARING_TYPE.SHARED },
      ],
    ],
  ],
  translation: { displayName: "Traductions" },
  tabs: [
    {
      title: {
        create: "Configuration",
        edit: "Modifier",
      },
    },
    {
      title: "Code promo à usage unique",
    },
  ],
  fields: {
    list: [
      {
        fieldName: "ticker",
        displayName: "Identifiant",
      },
      {
        fieldName: "promotionType",
        displayName: "Typologie",
      },
      {
        fieldName: "sharingType",
        displayName: "Utilisation",
      },
      ...BookableTranslations.fields.list,
      {
        fieldName: "group",
        displayName: "Groupe",
        tooltip: "Accumulation des promotions",
      },
      {
        fieldName: `${RESTRICTION_TYPE.OPEN_TRAVEL}_value`,
        displayName: "Validité (travel w)",
      },
      {
        fieldName: `${RESTRICTION_TYPE.CLOSE_TRAVEL}_value`,
        displayName: "Exclusion (travel w)",
      },
      {
        fieldName: `${RESTRICTION_TYPE.LOCK}_value`,
        displayName: "Blocages (travel w)",
      },
      {
        fieldName: `${RESTRICTION_TYPE.OPEN_BOOKING}_value`,
        displayName: "Réservable (booking w)",
      },
      {
        fieldName: `${RESTRICTION_TYPE.CLOSE_BOOKING}_value`,
        displayName: "Exclusion (booking w)",
      },
      {
        fieldName: `${RESTRICTION_TYPE.MIN_STAY}_duration`,
        displayName: "Séjour min. (nuits)",
      },
      {
        fieldName: `${RESTRICTION_TYPE.MAX_STAY}_duration`,
        displayName: "Séjour max. (nuits)",
      },
      {
        fieldName: `${RESTRICTION_TYPE.MIN_NOTICE}_duration`,
        displayName: "Délai min. (j) (Libération)",
      },
      {
        fieldName: `${RESTRICTION_TYPE.MAX_NOTICE}_duration`,
        displayName: "Délai max. (j) (Libération)",
      },
      {
        fieldName: RESTRICTION_TYPE.CODE,
        displayName: "Codes",
      },
      {
        fieldName: "type",
        displayName: "Type",
      },
    ],
    form: [
      {
        fieldName: "infoMessageChainPromo",
        value: "Les modifications s'appliqueront à toutes les propriétés sélectionnées",
      },
      ...customBookableTranslations,
      ...BookableTranslations.fields.form,
      {
        fieldName: "rateTypeSection",
        displayName: "Typologie",
      },
      {
        fieldName: "rateType",
        options: [
          {
            ticker: RATE_TYPE.PERCENTAGE,
            name: "Réduction %",
          },
          {
            ticker: RATE_TYPE.CONSTANT,
            name: "Réduction fixe/jour",
          },
          {
            ticker: RATE_TYPE.GIVE_NIGHT,
            name: "Offrir nuit(s) (ex:3x2)",
          },
          {
            ticker: RATE_TYPE.HIGHLIGHT_MESSAGE,
            name: "Message promotionnel",
          },
        ],
      },
      {
        fieldName: "group",
        displayName: "Groupe",
      },
      {
        fieldName: "ratePercentage",
        displayName: "Quantité",
        helpText:
          "Pourcentage de réduction qui sera appliqué au prix de l'hébergement soumis à la promotion",
      },
      {
        fieldName: "rateConstant",
        displayName: "Quantité",
        helpText:
          "Réduction fixe par jour qui sera appliquée au prix de l'hébergement soumis à la promotion",
      },
      {
        fieldName: "accumulationPromotions",
        openContainerText: "Voir l'accumulation des promotions",
        closeContainerText: "Masquer l'accumulation des promotions",
      },
      {
        fieldName: "accumulationPromotionsSection",
        displayName: "Accumulation des promotions",
        subtitle:
          "Seules les promotions appartenant à différents groupes seront cumulées. S'il y a plusieurs promotions applicables du même groupe, celle qui offre le plus grand avantage sera choisie.",
      },
      {
        fieldName: RESTRICTION_TYPE.LOCK,
        displayName: "Bloquer",
        description:
          "Permettre de désactiver la promotion pour certaines dates dans la section Inventaire > Gestion",
      },
      {
        fieldName: "stayDatesSection",
        displayName: "Dates de séjour (fenêtre de voyage)",
      },
      {
        fieldName: RESTRICTION_TYPE.OPEN_TRAVEL_START_DATE,
        displayName: "Date de début",
        placeholder: "Entrez une date",
      },
      {
        fieldName: RESTRICTION_TYPE.OPEN_TRAVEL_END_DATE,
        displayName: "Date de fin",
        placeholder: "Entrez une date",
      },
      {
        fieldName: "codeType",
        optionDisplay: {
          [CODE_TYPE.NO_CODE]: {
            label: "Sans code",
          },
          [CODE_TYPE.UNIVERSAL_CODE]: {
            label: "Code universel",
          },
        },
      },
      {
        fieldName: "showPopup",
        displayName: "Afficher une fenêtre contextuelle avec la description des promotions",
      },
      {
        fieldName: "restrictionsSection",
        displayName: "Restrictions",
      },
      {
        fieldName: RESTRICTION_TYPE.MIN_STAY,
        description: "Séjour min. (nuits)",
      },
      {
        fieldName: RESTRICTION_TYPE.MAX_STAY,
        description: "Séjour max. (nuits)",
      },
      {
        fieldName: RESTRICTION_TYPE.MIN_NOTICE,
        description: "Délai min. (jours)",
      },
      {
        fieldName: RESTRICTION_TYPE.MAX_NOTICE,
        description: "Délai max. (jours)",
      },
      {
        fieldName: "deviceSection",
        displayName: "Appareils activés",
        subtitle:
          "Cette promotion sera appliquée aux utilisateurs connectés depuis les appareils choisis.",
      },
      {
        fieldName: RESTRICTION_TYPE.DEVICE_TYPE,
        displayName: "",
        options: [
          {
            ticker: DEVICE_TYPE.DESKTOP,
            name: "Ordinateur",
          },
          {
            ticker: DEVICE_TYPE.TABLET,
            name: "Tablette",
          },
          {
            ticker: DEVICE_TYPE.MOBILE,
            name: "Mobile",
          },
        ],
      },
      {
        fieldName: "geoLocationSection",
        displayName: "Géolocalisation",
        widget: "section",
        subtitle:
          "Cette promotion ne s'appliquera qu'aux utilisateurs dont l'IP provient des pays marqués dans la liste des pays inclus",
      },
      {
        fieldName: RESTRICTION_TYPE.GEOLOCATION,
        options: getTranslatedCountryList("fr"),
        leftListHeader: "Pays inclus",
        rightListHeader: "Pays exclus",
      },
      {
        fieldName: "sharingType",
        displayName: "Utilisation",
        optionDisplay: {
          [SHARING_TYPE.SIMPLE]: {
            label: "Affiché uniquement dans l'agrégateur",
          },
          [SHARING_TYPE.SHARED]: {
            label: "Partagé",
          },
        },
      },
      {
        fieldName: "appliesToInventoriesSection",
        displayName: "Lignes d'inventaire",
        subtitle: "Cette promotion ne s'appliquera qu'aux lignes d'inventaire sélectionnées.",
      },
      {
        fieldName: "appliesToInventories",
        displayName: "Chambres avec la promotion activée :",
        filterNames: ["Hébergement", "Conditions", "Configuration", "Formule de repas"],
      },
      {
        fieldName: "icon",
        displayName: "Icône",
        placeholder: "Pas d'icône",
        optionLabelRenderer: ({ value, name }) => (
          <div style={{ display: "flex", alignItems: "center" }}>
            <span style={{ fontSize: 6, marginRight: "5px" }}>
              <i className="material-icons">{removeIconSetIdentifier(value)}</i>
            </span>
            <span style={{ fontSize: 14 }}>{name}</span>
          </div>
        ),
      },
      {
        fieldName: "infoMessage",
        value:
          "Pour activer l'onglet des codes promo à usage unique, vous devez d'abord enregistrer une promotion et y accéder à nouveau pour l'éditer.",
      },
      {
        displayName: "Période de réservation",
        widget: "section",
        fieldName: "bookingWindowSection",
      },
      { fieldName: "bookingWindow", nestedTitle: "Période de réservation" },
    ],
  },
  validation: {
    [RESTRICTION_TYPE.OPEN_TRAVEL_START_DATE]: {
      constraints: {
        compare: {
          message: "^La date de fin doit être postérieure à la date de début.",
        },
      },
    },
    [RESTRICTION_TYPE.OPEN_TRAVEL_END_DATE]: {
      constraints: {
        compare: {
          message: "^La date de fin doit être postérieure à la date de début et à aujourd'hui.",
        },
      },
    },
  },
};
